import { render, staticRenderFns } from "./LightBox.vue?vue&type=template&id=4587ccf8&scoped=true"
import script from "./LightBox.vue?vue&type=script&lang=js"
export * from "./LightBox.vue?vue&type=script&lang=js"
import style0 from "./LightBox.vue?vue&type=style&index=0&id=4587ccf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4587ccf8",
  null
  
)

export default component.exports